module.exports = __webpack_public_path__ + "static/media/cloud-database-tree.cea91a9a.svg";